import { motion } from "framer-motion";
import { Play, Users } from 'lucide-react';

const testimonials = [
{
  quote: "De zero a apresentação em 4 meses",
  name: "Carlos",
  role: "analista de sistemas",
  image: "https://static.lumi.new/ea/eace40cb9be734369613b6de20113a79.png",
  borderColor: "border-blue-500",
  icon: <Play className="w-8 h-8 text-white" />
},
{
  quote: "Finalmente parei de travar em reuniões",
  name: "Mariana",
  role: "gerente de projetos",
  image: "https://static.lumi.new/26/26044f8b3036b69f96766bc3fdf71e77.png",
  borderColor: "border-red-500",
  icon: null
},
{
  quote: "Minha primeira viagem sozinho para NY",
  name: "Pedro",
  role: "estudante de medicina",
  image: "https://static.lumi.new/2c/2c2f4ab3497be324e75c18e806c31977.png",
  borderColor: "border-blue-500",
  icon: null
}];


export default function SocialProofCarousel() {
  return (
    <section className="bg-gray-50 py-12 md:py-16">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) =>
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: i * 0.15 }}
            className={`bg-white rounded-2xl shadow-md hover:shadow-xl transition-shadow duration-300 overflow-hidden border-l-4 ${t.borderColor}`}>

              <div className="relative h-48 overflow-hidden">
                <img
                src={t.image}
                alt={t.name}
                className="w-full h-full object-cover" />

                {t.icon &&
              <div className="absolute inset-0 flex items-center justify-center bg-black/30">
                    


                  </div>
              }
              </div>
              <div className="p-5">
                <p className="font-serif text-lg font-semibold text-blue-900 mb-2">
                  "{t.quote}"
                </p>
                <p className="text-gray-500 text-sm">
                  — {t.name}, {t.role}
                </p>
              </div>
            </motion.div>
          )}
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="flex items-center justify-center gap-3 mt-10">

          <div className="flex -space-x-3">
            {[
            "https://images.pexels.com/photos/774909/pexels-photo-774909.jpeg?auto=compress&cs=tinysrgb&w=100",
            "https://images.pexels.com/photos/1239291/pexels-photo-1239291.jpeg?auto=compress&cs=tinysrgb&w=100",
            "https://images.pexels.com/photos/1681010/pexels-photo-1681010.jpeg?auto=compress&cs=tinysrgb&w=100",
            "https://images.pexels.com/photos/733872/pexels-photo-733872.jpeg?auto=compress&cs=tinysrgb&w=100",
            "https://images.pexels.com/photos/91227/pexels-photo-91227.jpeg?auto=compress&cs=tinysrgb&w=100"].
            map((src, i) =>
            <img
              key={i}
              src={src}
              alt="aluno"
              className="w-10 h-10 rounded-full border-2 border-white object-cover shadow" />

            )}
          </div>
          <div className="flex items-center gap-2">
            <Users className="w-5 h-5 text-blue-600" />
            <p className="text-blue-900 font-bold text-lg pl-[15px]">
              Junte-se a <span className="text-red-600">10.000+</span> alunos transformados
            </p>
          </div>
        </motion.div>
      </div>
    </section>);

}